@if (isAllowed && (activeKind$ | async); as activeKind) {
  <div class="kind-switch">
    @for (option of options; track trackByIndex($index)) {
      <button type="button" class="kind-btn" [class.active]="activeKind === option.value"
        (click)="select(option.value)">{{ option.label | translate }}</button>
    }
  </div>
}
